import React from "react";
import { connect } from "react-redux";
import { selectIsItemRemovalProcessing, selectIsRoomDesignProcessing, selectIsImageEditingProcessing, selectIsFloorPlanProcessing, selectIsPanoramaProcessing } from "../selectors";

interface TabNavBarProps {
  activeTab: string;
  onTabChange: (tabName: string) => void;
  isItemRemovalProcessing: boolean;
  isRoomDesignProcessing: boolean;
  isImageEditingProcessing: boolean;
  isFloorPlanProcessing: boolean;
  isPanoramaProcessing: boolean;
}

const TabNavBar: React.FC<TabNavBarProps> = ({
  activeTab,
  onTabChange,
  isItemRemovalProcessing,
  isRoomDesignProcessing,
  isImageEditingProcessing,
  isFloorPlanProcessing,
  isPanoramaProcessing
}) => {
  // いずれかの機能が処理中かどうか
  const isAnyProcessing = isItemRemovalProcessing || isRoomDesignProcessing || isImageEditingProcessing || isFloorPlanProcessing || isPanoramaProcessing;
  return (
    <div className="max-w-8xl w-full mx-auto py-3 px-4 sm:px-6 md:px-8">
      <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200">
        <li className="me-2">
          <button
            className={`inline-block p-4 rounded-t-lg ${
              activeTab === "roomDesign"
                ? "text-white bg-orange-500 shadow-md"
                : "text-gray-700 bg-gray-100 hover:bg-gray-200"
            } ${isAnyProcessing && activeTab !== "roomDesign" ? "opacity-50 cursor-not-allowed" : ""}`}
            type="button"
            onClick={() => !isAnyProcessing && onTabChange("roomDesign")}
            disabled={isAnyProcessing && activeTab !== "roomDesign"}
          >
            AIホームステージング
          </button>
        </li>
        <li className="me-2">
          <button
            className={`inline-block p-4 rounded-t-lg ${
              activeTab === "itemRemoval"
                ? "text-white bg-orange-500 active"
                : "bg-gray-100 text-gray-600 hover:text-gray-700 hover:bg-gray-200"
            } ${isAnyProcessing && activeTab !== "itemRemoval" ? "opacity-50 cursor-not-allowed" : ""}`}
            type="button"
            onClick={() => !isAnyProcessing && onTabChange("itemRemoval")}
            disabled={isAnyProcessing && activeTab !== "itemRemoval"}
          >
            AI家具消し
          </button>
        </li>
        <li className="me-2">
          <button
            className={`inline-block p-4 rounded-t-lg ${
              activeTab === "imageEditing"
                ? "text-white bg-orange-500 active"
                : "bg-gray-100 text-gray-600 hover:text-gray-700 hover:bg-gray-200"
            } ${isAnyProcessing && activeTab !== "imageEditing" ? "opacity-50 cursor-not-allowed" : ""}`}
            type="button"
            onClick={() => !isAnyProcessing && onTabChange("imageEditing")}
            disabled={isAnyProcessing && activeTab !== "imageEditing"}
          >
            画像編集
          </button>
        </li>
        <li className="me-2">
          <button
            className={`inline-block p-4 rounded-t-lg ${
              activeTab === "floorPlan"
                ? "text-white bg-orange-500 active"
                : "bg-gray-100 text-gray-600 hover:text-gray-700 hover:bg-gray-200"
            } ${isAnyProcessing && activeTab !== "floorPlan" ? "opacity-50 cursor-not-allowed" : ""}`}
            type="button"
            onClick={() => !isAnyProcessing && onTabChange("floorPlan")}
            disabled={isAnyProcessing && activeTab !== "floorPlan"}
          >
            マイソク編集
          </button>
        </li>
        <li className="me-2">
          <button
            className={`inline-block p-4 rounded-t-lg ${
              activeTab === "panorama"
                ? "text-white bg-orange-500 active"
                : "bg-gray-100 text-gray-600 hover:text-gray-700 hover:bg-gray-200"
            } ${isAnyProcessing && activeTab !== "panorama" ? "opacity-50 cursor-not-allowed" : ""}`}
            type="button"
            onClick={() => !isAnyProcessing && onTabChange("panorama")}
            disabled={isAnyProcessing && activeTab !== "panorama"}
          >
            パノラマステージング
          </button>
        </li>
      </ul>
    </div>
  );
};

interface RootState {
  itemRemoval: {
    isLoading: boolean;
    selectedRegenImage: string | null;
    [key: string]: unknown;
  };
  roomDesign: {
    isLoading: boolean;
    selectedRegenImage: string | null;
    [key: string]: unknown;
  };
  imageEditing: {
    isProcessing: boolean;
    [key: string]: unknown;
  };
  floorPlanExtraction: {
    isLoading: boolean;
    [key: string]: unknown;
  };
  panorama: {
    isLoading: boolean;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

const mapStateToProps = (state: RootState) => ({
  isItemRemovalProcessing: selectIsItemRemovalProcessing(state),
  isRoomDesignProcessing: selectIsRoomDesignProcessing(state),
  isImageEditingProcessing: selectIsImageEditingProcessing(state),
  isFloorPlanProcessing: selectIsFloorPlanProcessing(state),
  isPanoramaProcessing: selectIsPanoramaProcessing(state)
});

export default connect(mapStateToProps)(TabNavBar);
